import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { DefaultInspectionAttachment } from "../api/dto";
import { ModalFooter } from "../components/layout/ModalProvider";

export const DeleteDefaultInspectionAttachmentModal: FC<{
  attachment: DefaultInspectionAttachment;
  reload: (silently: boolean) => Promise<void>;
}> = (props) => {
  const { deleteDefaultInspectionAttachment } = useApiCall();
  const [errors, setErrors] = useState<string[]>([]);

  const confirm = async () => {
    await deleteDefaultInspectionAttachment(props.attachment.id)
      .catch((e) => {
        if (e instanceof ValidationError) {
          setErrors(Object.values(e.errors).flat());
        }
        throw e;
      })
      .then(() => {
        props.reload(true);
      });
  };

  return (
    <>
      <div>
        <strong>Let op!</strong> je staat op het punt om <strong>{props.attachment.name}</strong> te
        verwijderen.
      </div>
      <ModalFooter text={"Verwijderen"} icon={faTrash} onSubmit={confirm} />
    </>
  );
};
